import SearchFormMinimal from 'components/SearchFormMinimal/SearchFormMinimal'

export default SearchFormMinimal
